import { ThemeOption } from '@helpers/brand';
import { getSrcs } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import React from 'react';
import Breadcrumb from '../Global/Breadcrumb/Breadcrumb';
import { ArticleBannerStyles as S } from './ArticleBanner.styles';
const ArticleBanner = ({ breadcrumb, categoryTags, date, id, image, theme = ThemeOption.Orange, title, }) => {
    const [citationOpen, setCitationOpen] = React.useState(false);
    const srcs = getSrcs(image, 1720, 400, 8, 400 / 1720);
    return (React.createElement(S.Container, { flush: "top", theme: theme, id: id },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaArea, null,
                srcs && (React.createElement(S.PromoImage, { alt: image.altText ?? '', loading: "eager", role: image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(','), width: "1720", height: "396" })),
                image.citation && (React.createElement(S.CitationBtn, { type: "button", "data-citation-open": citationOpen, onClick: () => setCitationOpen(!citationOpen) },
                    React.createElement(S.CitationIcon, null, "i"),
                    React.createElement(S.CitationContent, null, image.citation)))),
            React.createElement(S.ContentArea, null,
                breadcrumb && React.createElement(Breadcrumb, { items: breadcrumb }),
                React.createElement(S.BannerTitle, null, title),
                date && (React.createElement(S.Date, null,
                    React.createElement(S.DateIcon, null, getSvgFromSystem(SystemIcon.Calendar)),
                    date)),
                categoryTags && (React.createElement(S.CategoryTags, null,
                    !!categoryTags.length && getSvgFromSystem(SystemIcon.Tag),
                    categoryTags.map((category, index) => (React.createElement("a", { href: category.url, target: category.target ?? '_self', key: `category-${index}` },
                        React.createElement("span", null, category.text))))))))));
};
export default ArticleBanner;
